import { render } from "./PopupInfo.vue?vue&type=template&id=45e31414"
import script from "./PopupInfo.vue?vue&type=script&lang=js"
export * from "./PopupInfo.vue?vue&type=script&lang=js"

import "./PopupInfo.vue?vue&type=style&index=0&id=45e31414&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__